export class Phone {
  number: string;
  internationalNumber: string;
  nationalNumber: string;
  countryCode: string;
  dialCode: string;
}
